/* istanbul ignore file */
import React from 'react';

import { DelayedSuspense } from '@lumapps/lumx-suspense/components/DelayedSuspense';

import { UploadImageDialogProps } from './UploadImageDialog';

const LazyUploadImageDialog = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'upload-image-dialog' */
            './UploadImageDialog'
        ),
);

export const UploadImageDialog = <IsMultiple extends boolean>(props: UploadImageDialogProps<IsMultiple>) => {
    const { isOpen } = props;

    return (
        <DelayedSuspense isDialog shouldLoad={isOpen}>
            <LazyUploadImageDialog {...props} />
        </DelayedSuspense>
    );
};
